import React from "react";
import registry from "../../seo/contentRegistry.generated.json";
import { DestinationPage, RegisteredPublicPage } from "./PublicContentPage";

export default function EsimLandingPage({ destinationKey }) {
  if (destinationKey) return <DestinationPage destinationKey={destinationKey} />;
  return <RegisteredPublicPage pageKey="esim" />;
}

export const DESTINATIONS = registry.destinations;
